import {launch} from '../modal';

function checkScreensize(form, authPopup, searchPanel, mybPanel, overlay, link) {
    let title = authPopup.querySelector('modal-title') as HTMLElement;
    let titlemove = authPopup.closest('div.stage').querySelector('.modal-header .modal-title') as HTMLElement;
    if (window.innerWidth >= 880) {
        overlay.style.display = 'none';
        link.click();
        searchPanel.classList.add('panel-hide');
        if (mybPanel && mybPanel.classList) {
            mybPanel.classList.remove('panel-hide');
            mybPanel.appendChild(form);
        }
    } else {
        mybPanel.classList.add('panel-hide');
        let title2;

        if (title !== null) {
            title2 = title;
        }

        if (title2) {
            titlemove.appendChild(title2);
        };
        authPopup.appendChild(form);
    }
}

function getUrlPrefix(url) {
    let prefix = url.split('emirates');
    return prefix[0];
}

function getUrl(data) {
    if (data && data.info) {
        let lang = data.info.Languages;
        let code = lang.filter(x => x.Code !== 'ar-AE' ? x.Code : null);
        let langCode = code[0].Code;
        langCode = langCode.toLowerCase();
        langCode = langCode.split('-');

        let country = data.info.CountryCode;
        country = country.toLowerCase();
        let codes = `${country}_${langCode[0]}`;

        let bnd = data.bookingRef;
        bnd = bnd.split('/');
        let bndRef = bnd[1];
        let url = window.location.href;
        let prefix = getUrlPrefix(url);

        let domainName = data.info.Name;
        let domainId = data.info.Id;

        if (domainId === 107) {
            domainName = 'emiratesholidays.com';
            data.info.Label = 'UK';
        } else if (domainName !== 'emiratesholidays.com' &&
            domainName !== 'emiratesvacations.com') {
                return `/${codes}/dashboard/booking-details/${bndRef}`;
        }

        let fullURL = `${prefix}${domainName}`;
        let finalURL = `${fullURL}/${codes}/dashboard/booking-details/${bndRef}`;

        return finalURL;
    }
}

function shouldRedirect(domains, info) {
    if (info) {
        let id = info.DomainBookedOn.Id;
        let siteCountryCode = TRPCONFIG.Domain.CountryCode;
        let infoCountryCode = info.DomainBookedOn.CountryCode;

        if (domains.indexOf(id) !== -1 || siteCountryCode === infoCountryCode) {
            return false;
        }
    } else {
        return false;
    }

    return true;
}

export function launchRedirect(a: any): void {
    TRPCONFIG.Domain2.MybInfo = a;
    let domains = TRPCONFIG.Domain2.MYBdomainsToIgnore;
    let lastName = (<HTMLInputElement>document.querySelectorAll('.surname')[0]).value;
    if (a && a.BookingRef) {
        let bndDetails = {
            bookingRef: a.BookingRef,
            surname: lastName,
            info: a.DomainBookedOn
        };
        localStorage.setItem('bndDetails', JSON.stringify(bndDetails));
    }

    let redirect = shouldRedirect(domains, a);
    if (redirect) {
        launch('partials/auth/MybRedirect');
    }
}

export function launchOption(path: string, options: Object): void {
    launch('partials/auth/SignInPopUp', _.extend({ tab: path, cb: null }, options));

    let target = document;
    let found = false;
    let observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                let form = document.querySelector('.signin-form') as HTMLElement;
                let authPopup = document.querySelector('.auth-popup') as HTMLElement;

                if (form && !found) {
                    found = true;
                    let searchPanel = document.querySelector('.ekh-search-panel') as HTMLElement;
                    let mybPanel = document.querySelector('.ekh-myb-panel') as HTMLInputElement;
                    let modalHeader = document.querySelector('.modal-header') as HTMLElement;
                    let link = modalHeader.querySelector('a') as HTMLElement;
                    let overlay = modalHeader.closest('.modal-overlay') as HTMLElement;

                    checkScreensize(form, authPopup, searchPanel, mybPanel, overlay, link);

                    window.addEventListener('resize', function(){
                        checkScreensize(form, authPopup, searchPanel, mybPanel, overlay, link);
                    });

                    observer.disconnect();
                }
            });
    });

    let config = {
        subtree: true,
        attributes: true,
        childList: false,
        characterData: false
    };

    observer.observe(target, config);
}

export function launchNotification(a: any): void {
    launch('partials/Dashboard/NotificationsPopup', { alerts: a });
}

export function launchContactForm(path: string, options: Object): void {
    launch('partials/auth/ContactFormPopUp', _.extend({ tab: path, cb: null }, options));
}
